import "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as s } from "../../context/theme/hooks.js";
import c from "../../utils/colorWithOpacity/index.js";
const p = {
  xsmall: {
    horizontalOffset: 0,
    verticalOffset: 4,
    blur: 10,
    opacity: 0.03
  },
  small: {
    horizontalOffset: 0,
    verticalOffset: 4,
    blur: 14,
    opacity: 0.05
  },
  medium: {
    horizontalOffset: 0,
    verticalOffset: 6,
    blur: 20,
    opacity: 0.07
  },
  large: {
    horizontalOffset: 0,
    verticalOffset: 8,
    blur: 20,
    opacity: 0.09
  },
  xlarge: {
    horizontalOffset: 0,
    verticalOffset: 10,
    blur: 26,
    opacity: 0.12
  }
};
function y(t) {
  const o = p[t], { horizontalOffset: e, verticalOffset: r, blur: a, opacity: i } = o, f = s().shadow, l = c(f, i);
  return `${e}px ${r}px ${a}px ${l}`;
}
export {
  p as SHADOW_SIZE_TO_PROPERTIES_MAP,
  y as default
};
